import { useEffect, useState } from 'react';

// eslint-disable-next-line import/no-unresolved
import { UserMessageCreateParams } from '@sendbird/chat/lib/__definition';

import {
  adminName,
  channelsMetadata,
  chatActiveTab,
  ClientChatTypes,
  getAdminChannelUrl,
  getChannelProperties,
  PermissionsOfAdmin,
  setSelectedClient,
  TypeOfUser,
  userIdSelector,
} from '@pharmaplan/common';

import useAdminPermissions from '../Admin/useAdminPermissions';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';

import ChatManager from './ChatManager';

const { pharmacist, student, pharmacy, technician } = ClientChatTypes;

const useChatWindow = () => {
  const dispatch = useAppDispatch();

  const activeTab = useAppSelector(chatActiveTab);
  const { can } = useAdminPermissions();
  const canViewEngaged = can(PermissionsOfAdmin.ViewEngagedChat);

  const adminCreatedChannelUrl = useAppSelector(getAdminChannelUrl);
  const channelMetadata = useAppSelector(channelsMetadata);

  const adminCreatedChannelProps = useAppSelector(getChannelProperties);
  const { channelName, personnelId, userType } = adminCreatedChannelProps ?? {};
  const { updateCustomType, updateMetadata } = ChatManager();

  const userId: string = useAppSelector(userIdSelector);
  const adminUser = useAppSelector(adminName);

  const [firstMessage, setFirstMessage] = useState(false);
  const [channelUrl, setChannelUrl] = useState({
    url: '',
    channelName: '',
    personnelId: '',
    userType: '',
    isEngaged: false,
  });

  const beforeSendMessage = (params: UserMessageCreateParams) => {
    setFirstMessage(true);
    return params;
  };

  const handleChannelSelect = (channel: any) => {
    const { url, _name } = channel ?? {};
    const {
      user_type: inUserType,
      users,
      personnelId: inPersonnelId,
    } = channelMetadata?.[url] ?? {};

    const isEngaged = !!users && users !== userId;
    if (isEngaged && !canViewEngaged) return;

    setFirstMessage(false);
    dispatch(setSelectedClient(personnelId));
    setChannelUrl({
      userType: inUserType,
      personnelId: inPersonnelId,
      url: url ?? '',
      channelName: _name,
      isEngaged,
    });
  };

  const tabUserMap = {
    [pharmacy]: TypeOfUser.pharmacy,
    [pharmacist]: TypeOfUser.pharmacist,
    [technician]: TypeOfUser.technician,
    [student]: TypeOfUser.student,

  };

  const getChannelType = () =>
    `${userId}+${tabUserMap[activeTab as keyof typeof tabUserMap]}`;

  useEffect(() => {
    setChannelUrl((prev) =>
      ({
        ...prev,
        url: adminCreatedChannelUrl,
        channelName,
        userType,
        personnelId,
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminCreatedChannelUrl]);

  useEffect(() => {
    if (firstMessage && activeTab !== ClientChatTypes.users) {
      updateCustomType(channelUrl.url, getChannelType());
      updateMetadata(channelUrl.url, { username: adminUser, users: userId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstMessage]);

  return { channelUrl, handleChannelSelect, beforeSendMessage };
};

export default useChatWindow;
